import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { useMemo } from 'react';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { FullWidthContainer } from '@sorare/core/src/atoms/layout/FullWidthContainer';
import { createCardSorts } from '@sorare/core/src/lib/algolia';
import { CardPageSearch } from '@sorare/marketplace/src/components/market/CardPageSearch';
import { useDefaultFilters } from '@sorare/marketplace/src/hooks/useDefaultFilters';
import {
  backendClubPageFilters,
  clubPageFilters,
} from '@sorare/marketplace/src/searchCards/mlb/cardFilters';

import type { BaseballTeamSearch_teamInterface } from './__generated__/index.graphql.ts';

type Props = {
  team: BaseballTeamSearch_teamInterface;
};

const cardSorts = createCardSorts({ withHighestAverageScore: true });

export const Search = ({ team }: Props) => {
  const filters = useDefaultFilters({
    teamSlug: team.slug,
  });

  const cardFilters = useMemo(() => clubPageFilters(false), []);

  return (
    <FullWidthContainer>
      <CardPageSearch
        sport={Sport.BASEBALL}
        sorts={cardSorts}
        defaultSort="Newly Listed"
        analyticsTags={['Team', 'Baseball']}
        defaultFilters={filters}
        cardFilters={cardFilters}
        backendCardFilters={backendClubPageFilters}
        topic={{ type: 'team', label: team.name }}
      />
    </FullWidthContainer>
  );
};

Search.fragments = {
  team: gql`
    fragment BaseballTeamSearch_teamInterface on TeamInterface {
      slug
      name
    }
  ` as TypedDocumentNode<BaseballTeamSearch_teamInterface>,
};
